module.exports = __webpack_public_path__ + "img/pic_videoguide@2x.36acb7a7.png";